import { styled, TableCell } from '@material-ui/core';
import { TextColor } from '../../../../enums';
import { distances } from '../../../../styles';

const TableHeaderCell = styled(TableCell)({
  color: TextColor.SlateGrey,
  // Temporary fix for MUI styles issue not being properly applied in MUI v5 on digital showroom project
  // requires MUI update to V5 and style refactoring (removing makeStyles)
  padding: `${distances.px.xsmall} ${distances.px.base}`,
  borderBottom: 'none',
  width: 'max-content',

  '&.MuiTableCell-stickyHeader': {
    backgroundColor: 'inherit'
  },

  '&:first-child': {
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px'
  },

  '&:last-child': {
    borderTopRightRadius: '10px',
    borderBottomRightRadius: '10px'
  },

  '& p': {
    display: 'inline',
    fontWeight: ({ newDesign }: { newDesign?: boolean }) =>
      newDesign ? 400 : 700,
    fontSize: ({ newDesign }: { newDesign?: boolean }) =>
      newDesign ? 12 : '0.875rem',
    color: TextColor.Grey
  },
  '& button': {
    display: 'inline',
    padding: 5,
    margin: 0,

    '& svg': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }
});

export default TableHeaderCell;
